import { RootState } from '@store/store'
import { prop } from 'ramda'
import { createSelector } from 'reselect'

import { CHAT_MESSAGE_ALL, CHAT_MESSAGE_LIST, CHAT_MESSAGE_POST, GLOBAL_STATE } from '../constants/actionTypes'

const chatSelector = (state: RootState) => prop(GLOBAL_STATE, state)

export const chatMessageAllSelector = createSelector(chatSelector, data => data[CHAT_MESSAGE_ALL])

export const chatMessageListSelector = createSelector(chatSelector, data => data[CHAT_MESSAGE_LIST])

export const chatMessagePostSelector = createSelector(chatSelector, data => data[CHAT_MESSAGE_POST])
